const Cross = ({fill}) => (
  <svg width="27px" height="26px" viewBox="0 0 27 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <path fill={fill} d="M12.7928932,13.5 L0.646446609,1.35355339 L1.35355339,0.646446609 L13.5,12.7928932 L25.670384,0.622509189 L26.3774908,1.32961597 L14.2071068,13.5 L25.3535534,24.6464466 L24.6464466,25.3535534 L13.5,14.2071068 L1.69444444,26.0126623 L0.987337663,25.3055556 L12.7928932,13.5 Z"></path>
  </svg>
)

export default Cross



// WEBPACK FOOTER //
// ./app/javascript/packs/svg/Cross.js